import useSWR from 'swr';

import { get } from '@/utils/client';
import { ALL_SOCIAL_PROFILES_ANALYTICS } from '@/routes/apiEndpoints';

// Types
import type { AxiosError } from 'axios';
import type { KeyedMutator, SWRConfiguration } from 'swr';
import type { PostType } from '@/types/postType';
import type { KPIDataType } from '@/lib/analytics/kpis/kpi.type';

export type MutateTasksType = KeyedMutator<SocialProfilesAnalyticsType[]>;

type AnalyticsFieldsType = 'posts' | 'followers_evolution' | 'engagement_rate' | 'impressions';

export type SocialProfilesAnalyticsType = {
    analytics: Record<AnalyticsFieldsType, KPIDataType>;
    most_reached_post: PostType & {
        reach: number;
        social_profile_id: number;
    };
    most_engaged_post: PostType & {
        engagements: number;
        social_profile_id: number;
    };
};

const useAllSocialProfilesAnalytics = (
    options?: SWRConfiguration<SocialProfilesAnalyticsType, AxiosError<Error>>
) => {
    const {
        data: allSocialProfilesAnalytics,
        mutate: mutateAllSocialProfilesAnalytics,
        error: allSocialProfilesAnalyticsError,
        isLoading
    } = useSWR<SocialProfilesAnalyticsType, AxiosError<Error>>(
        ALL_SOCIAL_PROFILES_ANALYTICS,
        (url) => get(url).then((res) => res.data),
        {
            shouldRetryOnError: false,
            ...options
        }
    );

    return {
        allSocialProfilesAnalytics,
        mutateAllSocialProfilesAnalytics,
        allSocialProfilesAnalyticsError,
        isLoading
    };
};

export default useAllSocialProfilesAnalytics;
